import { useDrag } from 'react-dnd';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';
import React from 'react';

const BaasicDragAndDropItem = ({ item, onCanDragCallback, currentDropBox, ItemComponent, dragAndDropField }) => {
	const [{ isDragging }, drag] = useDrag(() => ({
		type: dragAndDropField,
		canDrag: item => onCanDragCallback(currentDropBox),
		item: { dragAndDropField: _.get(item, dragAndDropField), currentDropBox: currentDropBox, key: item.key },
		collect: monitor => ({
			isDragging: !!monitor.isDragging(),
		}),
	}));
	return <ItemComponent {...{ drag, isDragging, item }} />;
};

export default defaultTemplate(BaasicDragAndDropItem);
